import { FunctionComponent, MouseEvent, RefObject } from 'react';
import type { Props as ComponentProps } from './types';
import type { Recruitment } from '../../../types/recruitments';
import { CoverThumbsSlider } from '../../molecules/coverThumbsSlider';
import classnames from 'classnames';

type Props = ComponentProps & {
  recruitmentData: Recruitment;
  pageCategory: () => any;
  pageValue: () => any;
  handleSetSession: (event: MouseEvent<HTMLAnchorElement>) => void;
  handleAnchorClick: (event: MouseEvent<HTMLAnchorElement>) => void;
  containerRef?: RefObject<HTMLLIElement>;
};

export const Presentation: FunctionComponent<Props> = (props) => {
  const shouldShowAttentionPeople =
    props.isShowAttentionPeople && props.recruitmentData.attentionPeople > 5;
  // 未指定の場合は通常表示枠として扱う（類似求人枠のみ 'similar' を明示的に渡す）
  const dataListType = props.dataListType ?? 'normal';
  // GTMの要素表示トリガー（DOM変更監視）は計測クラスを持つ要素が挿入された時点で計測対象にする。
  // 求人データ取得前に計測クラスを付けると、画面内のカードが空のdata属性のまま発火してしまうため、
  // 取得後にだけ付与し、keyを切り替えて新しい要素として挿入し直す。
  const isMeasurable = Boolean(props.recruitmentData.id);

  return (
    <li
      key={isMeasurable ? 'measurable' : 'loading'}
      ref={props.containerRef}
      className={classnames(
        'articles-list-item',
        { 'gtm-recruitment-view-count': isMeasurable },
        'borderNone',
        { 'scouted': props.recruitmentData.isScouted }
      )}
      data-event-name='recruitments on screen'
      data-category={props.pageCategory()}
      data-value={props.pageValue()}
      data-recruitmentid={props.recruitmentData.id}
      data-companyid={props.recruitmentData.company_id}
      data-state={props.recruitmentNumber}
      data-list-type={dataListType}
    >
      {props.recruitmentData.id !== '' && (
        <article className="article-card-container">
          <div className="article-card--inner" style={{ paddingLeft: 0, paddingRight: 0 }}>
            {!props.isBrandPage &&
              (
                typeof props.dataCategory !== 'object' ||
                (props.dataCategory.companyRecruitmentList !== 'companyrecruitmentlist')
              ) && (
                <a
                  onClick={props.handleSetSession}
                  href={`/companies/${props.recruitmentData.company_id}`}
                  className="article-card"
                  data-event="click"
                  data-category={props.pageCategory()}
                  data-value={props.pageValue()}
                  data-click-point={props.dataClickPoint.company}
                  data-recruitmentid={props.recruitmentData.id}
                  data-companyid={props.recruitmentData.company_id}
                  data-state={props.recruitmentNumber}
                  data-list-type={dataListType}
                >
                  <p className="article__recruitment__card__title">
                    <span className="article-card-author-logo">
                      {props.recruitmentData.icon && (
                        <img src={props.recruitmentData.icon} alt={props.recruitmentData.company_name + 'のロゴ写真'} />
                      )}
                    </span>
                    <span className="article-card-author-name">{props.recruitmentData.company_name}</span>
                  </p>
                </a>
              )}
            <CoverThumbsSlider
              noimage={props.noimage}
              hoverIcon={props.hoverIcon}
              isPc={props.isPc}
              isCompany={props.isCompany}
              recruitmentId={props.recruitment_id}
              recruitmentData={props.recruitmentData}
              dataClickPoint={props.dataClickPoint}
              pageCategory={props.pageCategory}
              pageValue={props.pageValue}
              dataListType={dataListType}
              handleSetSession={props.handleSetSession}
              handleAnchorClick={props.handleAnchorClick}
              isNew={props.recruitmentData.isNew}
              regularEmployee={props.recruitmentData.regularEmployee}
              recruitmentNumber={props.recruitmentNumber ?? undefined}
            />
            <h2
              className={classnames(
                'article-card-heading',
                'article-card-heading-sp',
                {
                  'is-multiple':
                    (props.recruitmentData.images?.length ?? 0) > 1
                }
              )}
              style={{ paddingBottom: 0 }}
            >
              <a
                onClick={props.handleSetSession}
                href={`/recruitments/${props.recruitmentData.id}`}
                className="article-card"
                data-event="click"
                data-category={props.pageCategory()}
                data-value={props.pageValue()}
                data-click-point={props.dataClickPoint.title}
                data-recruitmentid={props.recruitmentData.id}
                data-companyid={props.recruitmentData.company_id}
                data-state={props.recruitmentNumber}
                data-list-type={dataListType}
              >
                {props.recruitmentData.recruitment_title}
              </a>
            </h2>
            <p className="article__recruitment__card__text">{props.recruitmentData.why_need_content}</p>
            <div className="article__recruitment__card__content">
              <div className="article__recruitment__card__content--left">
                {props.recruitmentData.employment_types && props.recruitmentData.employment_types.length !== 0 && (
                  <div>
                    <p key={props.recruitmentData.employment_types[0].name} className="tag">
                      <i className="fas fa-user"></i>
                      {props.recruitmentData.employment_types[0].name}
                    </p>
                    {/* タグで表示するので一旦コメントアウト */}
                    {/* {props.recruitmentData.regularEmployee && <span>正社員</span>} */}
                  </div>
                )}
                {props.recruitmentData.address !== '' && (
                  <div>
                    <p className="address">
                      <i className="fas fa-map-marker-alt"></i>
                      {props.recruitmentData.address}
                    </p>
                  </div>
                )}
                {props.recruitmentData.salary !== '' && (
                  <div>
                    <p className="salary">
                      <i className="fas fa-yen-sign"></i>
                      {props.recruitmentData.salary}
                    </p>
                  </div>
                )}
              </div>
              <div className="article__recruitment__card__content--right">
                {props.recruitmentData.occupation_names &&
                  props.recruitmentData.occupation_names.map((o) => (
                    <p key={o}>
                      {' '}
                      <i className="fas fa-tags"></i>
                      {o}
                    </p>
                  ))}
              </div>
            </div>
            {(props.recruitmentData.activeDateFixed ||
              props.recruitmentData.hasRecordOfHiring ||
              props.recruitmentData.isHighResponse ||
              shouldShowAttentionPeople) && (
                <div className="article__recruitment__card__tags">
                  {props.recruitmentData.isHighResponse && (
                    <p className="article__recruitment__card__tag">
                      返信率が高い企業
                    </p>
                  )}
                  {props.recruitmentData.activeDateFixed && (
                    <p className="article__recruitment__card__tag">
                      アクティブな企業
                    </p>
                  )}
                  {props.recruitmentData.hasRecordOfHiring && (
                    <p className="article__recruitment__card__tag">
                      採用実績あり
                    </p>
                  )}
                  {shouldShowAttentionPeople && (
                    <p className="article__recruitment__card__tag">
                      {props.recruitmentData.attentionPeople}人以上が注目
                    </p>
                  )}
                </div>
              )}
            <div className="article__recruitment__card__bottom">
              {props.recruitmentData.isBoost && (
                <div className="article__recruitment__card__point">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="136 -817 673 673" fill="#c8170d"><path d="m560.77-184 21.69-245.54H379.77L617.85-776h12.92l-33.69 246.31H809L573.69-184h-12.92ZM185-294v-32h295.77l-4.85 32H185Zm-49-170v-32h179.54L294-464H136Zm95.23-170v-32h206.92l-21.77 32H231.23Z" /></svg>
                  Boost
                </div>
              )}
              <time dateTime={props.recruitmentData.updated_at} className="article__recruitment__card__time">
                更新{props.recruitmentData.updated_at_fixed}
              </time>
            </div>
          </div>
        </article>
      )}
    </li>
  );
};
